import { Injectable, inject } from '@angular/core'
import { Product } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { ModalService } from 'src/shared/modal/modal.service'
import { ProductFormComponent, ProductFormOptions } from './product-form.component'

@Injectable()
export class ProductFormService {
  private readonly modal = inject(ModalService)


  showCreateProduct() {
    return this.show(null, { title: 'Create Product' })
  }

  showUpdateProduct(product: DeepReadonly<Product>) {
    return this.show(product, { title: 'Update Product' })
  }

  private show(product: DeepReadonly<Product>, options: ProductFormOptions) {
    return this.modal.openDialog<ProductFormComponent, ProductFormOptions, Product>(ProductFormComponent, { product, ...options }, {
      panelClass: ['tc-dialog', 'modal-xlg'],
      width: null,
      maxWidth: null,
      autoFocus: false,
    }).toPromise()
  }
}
